import React from 'react';
import { useTranslation } from 'react-i18next';
import '../css/MaintenanceBanner.css';
import useMaintenanceWindow from '../utils/useMaintenanceWindow';

const MaintenanceBanner = () => {
  const { t } = useTranslation('common');

  const shouldShowBanner = useMaintenanceWindow();

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <div className="maintenance-banner">
      <div className="maintenance-banner-content">
        <div className="maintenance-banner-icon">
          ⚠️
        </div>
        <div className="maintenance-banner-text">
          <strong>Maintenance Notice:</strong> {t('maintenance.bannerMessage')}
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
